/**
 * Province/State Code Mapper
 * Maps province/state names to ISO codes for US and Canada
 * Can be used across different parts of the theme
 * 
 * Note: Includes US states, DC, territories, and associated states (FM, MH, PW).
 * These are Compact of Free Association states, not US states, but are included
 * for completeness as they may appear in address forms.
 */

(function() {
    'use strict';

    // Province/State name to ISO code mapping
    // Includes US states, DC, territories, and associated states
    const PROVINCE_NAME_TO_CODE = {
        // United States
        "Alabama": "AL",
        "Alaska": "AK",
        "American Samoa": "AS",
        "Arizona": "AZ",
        "Arkansas": "AR",
        "Armed Forces Americas": "AA",
        "Armed Forces Europe": "AE",
        "Armed Forces Pacific": "AP",
        "California": "CA",
        "Colorado": "CO",
        "Connecticut": "CT",
        "Delaware": "DE",
        "District of Columbia": "DC",
        "Washington DC": "DC", // Alternative name
        "Federated States of Micronesia": "FM",
        "Micronesia": "FM", // Alternative name
        "Florida": "FL",
        "Georgia": "GA",
        "Guam": "GU",
        "Hawaii": "HI",
        "Idaho": "ID",
        "Illinois": "IL",
        "Indiana": "IN",
        "Iowa": "IA",
        "Kansas": "KS",
        "Kentucky": "KY",
        "Louisiana": "LA",
        "Maine": "ME",
        "Marshall Islands": "MH",
        "Maryland": "MD",
        "Massachusetts": "MA",
        "Michigan": "MI",
        "Minnesota": "MN",
        "Mississippi": "MS",
        "Missouri": "MO",
        "Montana": "MT",
        "Nebraska": "NE",
        "Nevada": "NV",
        "New Hampshire": "NH",
        "New Jersey": "NJ",
        "New Mexico": "NM",
        "New York": "NY",
        "North Carolina": "NC",
        "North Dakota": "ND",
        "Northern Mariana Islands": "MP",
        "Ohio": "OH",
        "Oklahoma": "OK",
        "Oregon": "OR",
        "Palau": "PW",
        "Pennsylvania": "PA",
        "Puerto Rico": "PR",
        "Rhode Island": "RI",
        "South Carolina": "SC",
        "South Dakota": "SD",
        "Tennessee": "TN",
        "Texas": "TX",
        "Utah": "UT",
        "Vermont": "VT",
        "Virgin Islands": "VI",
        "U.S. Virgin Islands": "VI", // Alternative name
        "Virginia": "VA",
        "Washington": "WA",
        "West Virginia": "WV",
        "Wisconsin": "WI",
        "Wyoming": "WY",
        "United States Minor Outlying Islands": "UM",

        // Canada
        "Alberta": "AB",
        "British Columbia": "BC",
        "Manitoba": "MB",
        "New Brunswick": "NB",
        "Newfoundland and Labrador": "NL",
        "Northwest Territories": "NT",
        "Nova Scotia": "NS",
        "Nunavut": "NU",
        "Ontario": "ON",
        "Prince Edward Island": "PE",
        "Quebec": "QC",
        "Saskatchewan": "SK",
        "Yukon": "YT"
    };

    // Build normalized (lowercase) lookup map for case-insensitive matching
    const PROVINCE_NAME_TO_CODE_LOWER = {};
    for (const key in PROVINCE_NAME_TO_CODE) {
        if (PROVINCE_NAME_TO_CODE.hasOwnProperty(key)) {
            PROVINCE_NAME_TO_CODE_LOWER[key.trim().toLowerCase()] = PROVINCE_NAME_TO_CODE[key];
        }
    }

    /**
     * Converts a province/state name to its ISO code (case-insensitive)
     * @param {string} provinceName - The full name of the province/state
     * @returns {string} - The ISO code (2-3 characters) or the original name if not found
     */
    window.getProvinceCode = function(provinceName) {
        if (!provinceName || typeof provinceName !== 'string') {
            return '';
        }

        const trimmed = provinceName.trim();
        if (!trimmed) {
            return '';
        }

        // Check if it's already a code (2-3 uppercase letters)
        // Normalize to uppercase for the test
        const upperTrimmed = trimmed.toUpperCase();
        if (upperTrimmed.length <= 3 && /^[A-Z]{2,3}$/.test(upperTrimmed)) {
            return upperTrimmed;
        }

        // Try case-insensitive lookup using normalized map
        const normalizedKey = trimmed.toLowerCase();
        const code = PROVINCE_NAME_TO_CODE_LOWER[normalizedKey];
        return code || trimmed;
    };

    /**
     * Gets the mapping object (useful for debugging or advanced use cases)
     * @returns {Object} - The complete mapping object
     */
    window.getProvinceMapping = function() {
        return Object.assign({}, PROVINCE_NAME_TO_CODE);
    };
})();
